import React from 'react';
import { siteStats } from '../data/stats.js';
import { contentEs } from '../data/contentEs.js';
import { contentEn } from '../data/contentEn.js';

interface StatsBannerProps {
  isEn?: boolean;
}

export const StatsBanner: React.FC<StatsBannerProps> = ({ isEn = false }) => {
  const c = isEn ? contentEn : contentEs;

  return (
    <section className="bg-[#FAF8F5] border-y border-[#EAE6DE] py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 text-center divide-y md:divide-y-0 md:divide-x divide-[#E2DDCF]">
          {/* Stat 1 */}
          <div className="pt-4 md:pt-0">
            <div className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl text-[#001557] tracking-tight">
              {siteStats.since}
            </div>
            <div className="mt-2 text-sm sm:text-base font-semibold text-[#4B5563] uppercase tracking-wider">
              {c.home.stats.sinceLabel}
            </div>
          </div>

          {/* Stat 2 */}
          <div className="pt-4 md:pt-0">
            <div className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl text-[#001557] tracking-tight">
              {siteStats.locations}
            </div>
            <div className="mt-2 text-sm sm:text-base font-semibold text-[#4B5563] uppercase tracking-wider">
              {c.home.stats.locationsLabel}
            </div>
          </div>

          {/* Stat 3 */}
          <div className="pt-4 md:pt-0">
            <div className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl text-[#001557] tracking-tight">
              {siteStats.operationPoints}
            </div>
            <div className="mt-2 text-sm sm:text-base font-semibold text-[#4B5563] uppercase tracking-wider">
              {c.home.stats.pointsLabel}
            </div>
          </div>

          {/* Stat 4 */}
          <div className="pt-4 md:pt-0">
            <div className="font-heading font-black text-4xl sm:text-5xl lg:text-6xl text-[#001557] tracking-tight">
              +{siteStats.monthlyPlates.toLocaleString()}
            </div>
            <div className="mt-2 text-sm sm:text-base font-semibold text-[#4B5563] uppercase tracking-wider">
              {c.home.stats.platesLabel}
            </div>
          </div>
        </div>

        {/* Centered closing slogan */}
        <div className="mt-12 pt-10 border-t border-[#EAE6DE] text-center max-w-2xl mx-auto">
          <p className="font-heading font-extrabold text-xl sm:text-2xl text-[#001557]">
            {c.home.stats.tagline}
          </p>
          <p className="mt-1.5 text-base text-[#4B5563] font-medium">
            {c.home.stats.subtagline}
          </p>
        </div>
      </div>
    </section>
  );
};
